import * as UI from "@iyk/ui"
import * as React from "react"

import { Form } from "@remix-run/react"

export const Root = ({
  prefixId,
  className,
  children,
}: {
  prefixId: string
  className?: string
  children: React.ReactNode
}) => (
  <PrefixIdContext.Provider value={prefixId}>
    <Form className={UI.cx("flex flex-col gap-4 mt-8 text-sm", className)} method="POST">
      {children}
    </Form>
  </PrefixIdContext.Provider>
)

const classForField = UI.cx("flex flex-col gap-2")

export const Field = ({
  name,
  label,
  className,
  children,
}: {
  name: string
  label: string
  className?: string
  children: React.ReactNode
}) => {
  const id = getFieldId(name)
  return (
    <div className={UI.cx(classForField, className)}>
      <label htmlFor={id}>{label}</label>
      {children}
    </div>
  )
}
export const FirstName = ({ className }: { className?: string }) => {
  const id = getFieldId("firstName")
  return (
    <Field name="firstName" label="First name" className={className}>
      <UI.TextControl
        type="text"
        autoComplete="firstName"
        id={id}
        name="firstName"
        style={{ width: "100%" }}
      />
    </Field>
  )
}

export const LastName = ({ className }: { className?: string }) => {
  const id = getFieldId("lastName")
  return (
    <Field name="lastName" label="Last name" className={className}>
      <UI.TextControl
        type="text"
        autoComplete="family-name"
        id={id}
        name="lastName"
        style={{ width: "100%" }}
      />
    </Field>
  )
}

export const Quantity = ({ className }: { className?: string }) => {
  const id = getFieldId("quantity")
  return (
    <Field name="quantity" label="Quantity" className={className}>
      <UI.SelectControl
        id={id}
        name="quantity"
        required
        className="bshadow bshadow-gray-6 bg-select bg-no-repeat bg-[position:calc(100%_-_.5em)]"
      >
        <option>50-250</option>
        <option>250-1000</option>
        <option>1000-5000</option>
        <option>5000+</option>
      </UI.SelectControl>
    </Field>
  )
}

export const Email = ({ className }: { className?: string }) => {
  const id = getFieldId("email")
  return (
    <Field name="email" label="Email" className={className}>
      <UI.TextControl type="email" autoComplete="email" id={id} name="email" required />
    </Field>
  )
}

export const Message = ({ className }: { className?: string }) => {
  const id = getFieldId("message")
  return (
    <Field name="message" label="Message" className={className}>
      <UI.TextControl
        type="textarea"
        id={id}
        name="message"
        placeholder="Tell us about your project"
      />
    </Field>
  )
}

export const Design = ({ className }: { className?: string }) => {
  return (
    <Field name="design" label="Design" className={className}>
      <div className="flex gap-x-4">
        <div className="flex gap-x-2 items-center">
          <UI.RadioControl defaultChecked name="design" value="custom" id={getFieldId("custom")}>
            Custom
          </UI.RadioControl>
        </div>
        <div className="flex gap-x-2 items-center">
          <UI.RadioControl name="design" value="standard" id={getFieldId("standard")}>
            Standard
          </UI.RadioControl>
        </div>
      </div>
    </Field>
  )
}

export const SmallSubmitButton = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col items-end">
    <UI.Button type="submit" variant="secondary">
      {children}
    </UI.Button>
  </div>
)

export const LargeSubmitButton = ({ children }: { children: React.ReactNode }) => (
  <UI.Button type="submit" variant="primary" className="w-full">
    {children}
  </UI.Button>
)

export const SuccessBlock = () => (
  <span className="flex flex-col gap-1">
    <p className="text-xs-upper text-center">Success</p>
    <p className="text-sm text-center">We'll be in touch</p>
  </span>
)

const PrefixIdContext = React.createContext<string | undefined>(undefined)

function getFieldId(name: string) {
  const prefix = React.useContext(PrefixIdContext)
  if (prefix === undefined) {
    throw new Error("Form components must be used within a Root component")
  }
  return `${prefix}_${name}`
}
